export default __webpack_public_path__ + "static/media/cross.dc9e0937.png";